import { SocietyProviderFilters } from '../../../app/models/SocietyProvider';
import ButtonTableAction from '../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../components/default/DefaultDataTable';
import ProviderFilter from './ProviderFilter';
import ProviderSwitchChange from './ProviderSwitchChange';

interface ProviderRow {
    id?: number;
    society?: { rut?: string; business_name?: string };
    rut?: string;
    business_name?: string;
    address?: string;
    country?: string;
    is_active?: boolean;
}

interface Props {
    providers: ProviderRow[];
    totalRows: number;
    loading?: boolean;
    edit?: (providerId: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (providerId: number) => void;
    destroy?: (providerId: number) => void;
    filter: SocietyProviderFilters;
    setFilter: (filter: SocietyProviderFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    onSearch: () => void;
}

const ProviderDataTable = ({
    providers,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    active,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'RUT Sociedad',
            selector: (row: any) => row.society?.rut || '',
            sortable: true,
            sortField: 'society__rut',
            cell: (row: ProviderRow) => <span>{row.society?.rut ?? '-'}</span>
        },
        {
            name: 'Razón Social Sociedad',
            selector: (row: any) => row.society?.business_name || '',
            sortable: true,
            sortField: 'society__business_name',
            cell: (row: ProviderRow) => (
                <span title={row.society?.business_name}>{row.society?.business_name ?? '-'}</span>
            )
        },
        {
            name: 'RUT Proveedor',
            selector: (row: any) => row.rut,
            sortable: true,
            sortField: 'rut',
            cell: (row: ProviderRow) => <span>{row.rut ?? '-'}</span>
        },
        {
            name: 'Razón Social Proveedor',
            selector: (row: any) => row.business_name,
            sortable: true,
            sortField: 'business_name',
            cell: (row: ProviderRow) => (
                <span title={row.business_name}>{row.business_name ?? '-'}</span>
            )
        },
        {
            name: 'Dirección Proveedor',
            selector: (row: any) => row.address,
            sortable: true,
            sortField: 'address',
            cell: (row: ProviderRow) => <span>{row.address ?? '-'}</span>
        },
        {
            name: 'País Proveedor',
            selector: (row: any) => row.country,
            sortable: true,
            sortField: 'country',
            cell: (row: ProviderRow) => <span>{row.country ?? '-'}</span>
        },
        {
            name: 'Activo',
            selector: (row: any) => row?.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: ProviderRow) => (
                <ProviderSwitchChange
                    checkValue={row.is_active ?? true}
                    societyProviderId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: ProviderRow) => (
                <div>
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <ProviderFilter filter={filter} setFilter={setFilter} onSearch={onSearch}/>
                </div>
            </div>
            <DefaultDataTable
                columns={columns}
                data={providers}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default ProviderDataTable;